module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.11eabca.ttf";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/src/fonts/Roboto-Regular.ttf
// module id = CQkB
// module chunks = 1